<template>
  <div class="ch-chip-nav bg-light-page sticky-top">
    <div class="ch-chips px-3 py-3 d-flex">
      <button
        v-for="s in sections"
        :key="s.id"
        @click="$emit('scroll-to', s.id)"
        :class="['ch-chip', 'body-3-3', 'font-bold', 'flex-shrink-0',
          { 'ch-chip--active': activeSection === s.id },
          { 'ch-chip--tip': s.id === 'tip' && activeSection !== 'tip' }]"
      >
        <template v-if="s.id === 'tip'">❤ </template>{{ s.label }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ConciergeChipNav',
    props: {
      sections:      { type: Array,  required: true },
      activeSection: { type: String, required: true },
    },
  }
</script>

<style scoped>
.ch-chip-nav {
  z-index: 10;
}

.ch-chips {
  gap: 7px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.ch-chips::-webkit-scrollbar { display: none; }

.ch-chip {
  padding: 8px 15px;
  border-radius: 999px;
  font-size: 12.5px;
  cursor: pointer;
  white-space: nowrap;
  border: 1.5px solid #E0E8EF;
  background: #fff;
  color: #1C2B36;
  font-family: inherit;
  transition: all .15s;
}

.ch-chip--active {
  background: #1C2B36;
  color: #fff;
  border-color: #1C2B36;
}

.ch-chip--tip {
  background: var(--merchant-text-color, #C97B5C);
  color: #fff;
  border-color: var(--merchant-text-color, #C97B5C);
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeChipNav.vue